import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import I18n from 'I18n';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function PlaybookUsageDetails({
  timesViewed,
  lastViewedAt
}) {
  return /*#__PURE__*/_jsxs(Small, {
    "data-selenium-test": "playbooks-list-item-details",
    children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "cardPlaybooks.playbooksIndex.usageDetails.timesViewed",
      options: {
        timesViewed
      }
    }), lastViewedAt ? /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(View, {
        marginInline: "100",
        as: "span",
        children: "\u2022"
      }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "cardPlaybooks.playbooksIndex.usageDetails.lastViewedAt",
        options: {
          lastViewedAt: I18n.moment.userTz(lastViewedAt).fromNow()
        }
      })]
    }) : null]
  });
}